import styled from 'styled-components'
import Checkbox from 'syf-component-library/ui/atoms/Checkbox'
import Select from 'syf-component-library/ui/atoms/Select'
import Textarea from 'syf-component-library/ui/atoms/Textarea'
import Textfield from 'syf-component-library/ui/atoms/Textfield'
import Body from 'syf-component-library/ui/typography/Body'
import ReactDatePicker from 'react-datepicker'
import { CheckboxContainer } from 'ui/molecules/RequestPage.styles'

const fontSize = '14px'
const inputFontSize = '16px'
const redColor = '#c63527'
const grayColor = '#fafafa'
const grayText = '#656565'
const subtextColor = '#676767'
const borderColor = '#9e9e9e'

export const BodyStyledAsError = styled('div')`
  margin-bottom: 2rem;
`

export const StyledH2 = styled.h2`
  font-size: 20px;
  line-height: 1.4;
`

export const StyledCaptcha = styled.h3`
  font-weight: normal;
  font-size: ${fontSize};
  max-width: '500px';
  width: '80vw';
  margin-bottom: 0;
  color: ${redColor};
`

export const StyledError = styled.div`
  font-size: ${fontSize};
  color: ${redColor};
  margin: auto;
  min-height: 24px;
  padding-left: 5px;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  span {
    margin-left: 1rem;
  }
`

export const StyledTextfield = styled(Textfield)`
  min-height: 100px;
  div {
    overflow: hidden;
  }
  p {
    white-space: break-spaces;
  }
  input {
    font-family: Open Sans;
    font-size: ${inputFontSize};
    color: ${subtextColor};
  }
  label {
    color: ${grayText};
    ${({ error }) => (error ? `color: ${redColor};` : '')}
    ${({ isDisabled }) => (isDisabled ? `background-color: ${grayColor};` : '')}
  }
`

export const StyledSelectContainer = styled.div`
  min-height: 100px;
`

export const StyledSelect = styled(Select)`
  width: 275px;
  &:focus-within {
    box-shadow: 0 0 0 1px ${borderColor};
  }
  span {
    font-family: Open Sans;
    font-size: ${inputFontSize};
    color: ${subtextColor};
    bottom: 12px;
  }
  label {
    color: transparent;
  }
`

export const StyledQuestionText = styled.label`
  font-size: ${fontSize};
  margin-bottom: 5px;
  margin-top: 16px;
`

export const Disclaimer = styled(Body)`
  margin-top: 0;
`

export const Headline = styled.p`
  font-size: 24px;
  line-height: 1.33;
  text-align: left;
  font-weight: bolder;
`

export const StyledDatePicker = styled(ReactDatePicker)`
  width: 275px;
  position: relative;
  input {
    font-family: Open Sans;
    font-size: ${inputFontSize};
    color: ${subtextColor};
  }
`

export const StyledCheckbox = styled(Checkbox)`
  font-size: ${fontSize};
  line-height: 1.43;
  margin-bottom: 1.5rem;
  min-width: 200px;
  max-width: 100%;
`

export const StyledTextarea = styled(Textarea)`
  max-width: 600px;
`

export const Subtext = styled.p`
  margin-bottom: 28px;
  color: ${subtextColor};
  font-size: ${fontSize};
`

export const Message = styled.span`
  font-size: ${fontSize};
  position: relative;
  margin-top: 1rem;
  margin-bottom: 1rem;
`

export const CheckboxContainerPadding = styled(CheckboxContainer)`
  padding-top: 1px;
  width: 100%;
`
